import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: ${props => props.isScrolled ? '0.5rem 2rem' : '1rem 2rem'};
  transition: all 0.3s ease;
`;

const Nav = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.img`
  height: ${props => props.isScrolled ? '50px' : '100px'};
  transition: height 0.3s ease;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    display: ${props => props.isOpen ? 'flex' : 'none'};
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    flex-direction: column;
    background-color: white;
    padding: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

const NavLink = styled.a`
  color: #333;
  text-decoration: none;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  transition: color 0.3s ease;

  &:hover {
    color: #4CAF50;
  }
`;

const ContactButton = styled.a`
  background-color: #4CAF50;
  color: white;
  padding: 0.8rem 1.5rem;
  border-radius: 5px;
  text-decoration: none;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #45a049;
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #333;

  @media (max-width: 768px) {
    display: block;
  }
`;

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <HeaderContainer isScrolled={isScrolled}>
      <Nav>
        <Link to="/">
          <Logo src="/images/logo.png" alt="Sunbold" isScrolled={isScrolled} />
        </Link>
        <NavLinks isOpen={isMenuOpen}>
          <NavLink as={Link} to="/">Home</NavLink>
          <NavLink as={Link} to="/services">Services</NavLink>
          <NavLink as={Link} to="/projects">Projects</NavLink>
          <NavLink as={Link} to="/gallery">Gallery</NavLink>
          <NavLink as={Link} to="/about">About</NavLink>
          <ContactButton as={Link} to="/contact">Contact Us</ContactButton>
          <NavLink as={Link} to="/admin/login">Admin</NavLink>
        </NavLinks>
        <MenuButton onClick={() => setIsMenuOpen(!isMenuOpen)}>
          ☰
        </MenuButton>
      </Nav>
    </HeaderContainer>
  );
}

export default Header;
